import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormatSimple } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    {
      title: '药品编号',
      dataIndex: 'tenantMaterialsCatalogId',
      align: 'center',
      width: '7rem',
      ellipsis: true,
    },
    // {
    //   title: '自编码',
    //   dataIndex: 'name',
    //   align: 'center',
    //   width: '14rem',
    //   ellipsis: true,
    //   render: (_, t) => {
    //     return t.name ? t.name : '-'
    //   },
    // },
    {
      title: '商品名',
      dataIndex: 'name',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.name ? t.name : '-'
      },
    },
    {
      title: '通用名',
      dataIndex: 'genericName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.genericName ? t.genericName : '-'
      },
    },
    {
      title: '储存条件',
      dataIndex: 'putWay',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.putWay ? t.putWay : '-'
      },
    },
    {
      title: '外观质量',
      dataIndex: 'appearanceQuality',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.appearanceQuality == 1
          ? '合格'
          : t.appearanceQuality == 0
          ? '不合格'
          : '-'
      },
    },
    {
      title: '规范情况',
      dataIndex: 'normSituation',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.normSituation ? t?.normSituation : '-'
      },
    },
    {
      title: '进货质量评审情况',
      dataIndex: 'instockSituation',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.instockSituation ? t.instockSituation : '-'
      },
    },
    {
      title: '顾客质量评价',
      dataIndex: 'customRemark',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.customRemark ? t.customRemark : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '10rem',
      render: function Element(_, t) {
        return (
          <>
            <Button
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('edit', t)
              }}
            >
              编辑
            </Button>
            <Button
              danger
              style={{ marginRight: '6px' }}
              type='primary'
              ghost
              size='small'
              disabled={t?.isEdit == 1 ? false : true}
              onClick={() => {
                onClick('delete', t)
              }}
            >
              删除
            </Button>
          </>
        )
      },
    },
  ]
}
